import ArrowIcon from 'public/icons/arrow.svg'
import Burger2OutlineIcon from 'public/icons/burger2-outline.svg'
import ChartFillIcon from 'public/icons/chart-fill.svg'
import CheckIcon from 'public/icons/check.svg'
import ChestFillIcon from 'public/icons/chest-fill.svg'
import CircleIcon from 'public/icons/circle.svg'
import CloseIcon from 'public/icons/close.svg'
import CountriesIcon from 'public/icons/countries.svg'
import CrossOutlineIcon from 'public/icons/cross-outline.svg'
import DownOutlineIcon from 'public/icons/down-outline.svg'
import EnvelopeFillIcon from 'public/icons/envelope-fill.svg'
import EyeIcon from 'public/icons/eye.svg'
import EyeOffIcon from 'public/icons/eye-off.svg'
import EyeOutlineIcon from 'public/icons/eye-outline.svg'
import GameIcon from 'public/icons/game.svg'
import GamepadFillIcon from 'public/icons/gamepad-fill.svg'
import GlobeFillIcon from 'public/icons/globe-fill.svg'
import HeadphonesFillIcon from 'public/icons/headphones-fill.svg'
import InfoOutlineIcon from 'public/icons/info-outline.svg'
import InstaFillIcon from 'public/icons/insta-fill.svg'
import InstagramIcon from 'public/icons/instagram.svg'
import MedalIcon from 'public/icons/medal.svg'
import MessageIcon from 'public/icons/message.svg'
import RevenueIcon from 'public/icons/revenue.svg'
import SkypeFillIcon from 'public/icons/skype-fill.svg'
import StatsIcon from 'public/icons/stats.svg'
import SupportIcon from 'public/icons/support.svg'
import TelegramIcon from 'public/icons/telegram.svg'
import TelegramFillIcon from 'public/icons/telegram-fill.svg'
import WalletIcon from 'public/icons/wallet.svg'
import WalletFillIcon from 'public/icons/wallet-fill.svg'

export const iconMap = {
  arrow: ArrowIcon,
  'burger2-outline': Burger2OutlineIcon,
  'chart-fill': ChartFillIcon,
  check: CheckIcon,
  'chest-fill': ChestFillIcon,
  circle: CircleIcon,
  close: CloseIcon,
  countries: CountriesIcon,
  'cross-outline': CrossOutlineIcon,
  'down-outline': DownOutlineIcon,
  'envelope-fill': EnvelopeFillIcon,
  eye: EyeIcon,
  'eye-off': EyeOffIcon,
  'eye-outline': EyeOutlineIcon,
  game: GameIcon,
  'gamepad-fill': GamepadFillIcon,
  'globe-fill': GlobeFillIcon,
  'headphones-fill': HeadphonesFillIcon,
  'info-outline': InfoOutlineIcon,
  'insta-fill': InstaFillIcon,
  instagram: InstagramIcon,
  medal: MedalIcon,
  message: MessageIcon,
  revenue: RevenueIcon,
  'skype-fill': SkypeFillIcon,
  stats: StatsIcon,
  support: SupportIcon,
  telegram: TelegramIcon,
  'telegram-fill': TelegramFillIcon,
  wallet: WalletIcon,
  'wallet-fill': WalletFillIcon,
} as const

export type IconName = keyof typeof iconMap
